// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: prFzY4CsJhDpFsYFo29VMf
// Component: 584n9N-hkl

import * as React from "react";

import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";

import {
  hasVariant,
  classNames,
  wrapWithClassName,
  createPlasmicElementProxy,
  makeFragment,
  MultiChoiceArg,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  pick,
  omit,
  useTrigger,
  StrictProps,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";
import NewsLetter from "../../NewsLetter"; // plasmic-import: hz7eRhzEc6/component
import Button from "../../Button"; // plasmic-import: MznF3tGFZjD/component

import { useScreenVariants as useScreenVariants_5VS0GwAl4 } from "./PlasmicGlobalVariant__Screen"; // plasmic-import: -5vS0GW_al4/globalVariant

import "@plasmicapp/react-web/lib/plasmic.css";

import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_idea_hub.module.css"; // plasmic-import: prFzY4CsJhDpFsYFo29VMf/projectcss
import sty from "./PlasmicResourceModal.module.css"; // plasmic-import: 584n9N-hkl/css

import Icon5Icon from "./icons/PlasmicIcon__Icon5"; // plasmic-import: lV99kKMPXa/icon
import Icon6Icon from "./icons/PlasmicIcon__Icon6"; // plasmic-import: XAyjV5ljKq/icon
import LinksvgIcon from "./icons/PlasmicIcon__Linksvg"; // plasmic-import: wup7cgCFLJ/icon
import AdsClicksvgIcon from "./icons/PlasmicIcon__AdsClicksvg"; // plasmic-import: 5aGBELweXi/icon
import ClosesvgIcon from "./icons/PlasmicIcon__Closesvg"; // plasmic-import: ptXZFGuhmv/icon
import ChecksvgIcon from "./icons/PlasmicIcon__Checksvg"; // plasmic-import: OZSfMt1ZAhb/icon
import IconIcon from "./icons/PlasmicIcon__Icon"; // plasmic-import: QKCDMAfoLkN/icon
import Icon2Icon from "./icons/PlasmicIcon__Icon2"; // plasmic-import: Q_1iLw7C4y/icon
import Icon4Icon from "./icons/PlasmicIcon__Icon4"; // plasmic-import: mEWqrtEPYf/icon

createPlasmicElementProxy;

export type PlasmicResourceModal__VariantMembers = {};
export type PlasmicResourceModal__VariantsArgs = {};
type VariantPropType = keyof PlasmicResourceModal__VariantsArgs;
export const PlasmicResourceModal__VariantProps = new Array<VariantPropType>();

export type PlasmicResourceModal__ArgsType = {
  resourceDescription?: React.ReactNode;
  resourceLink?: React.ReactNode;
  resourceDescription2?: React.ReactNode;
  resourceLinkMobile?: React.ReactNode;
  resourceClicks?: React.ReactNode;
  resourceClicks2?: React.ReactNode;
  resourceImage?: React.ComponentProps<typeof p.PlasmicImg>["src"];
};
type ArgPropType = keyof PlasmicResourceModal__ArgsType;
export const PlasmicResourceModal__ArgProps = new Array<ArgPropType>(
  "resourceDescription",
  "resourceLink",
  "resourceDescription2",
  "resourceLinkMobile",
  "resourceClicks",
  "resourceClicks2",
  "resourceImage"
);

export type PlasmicResourceModal__OverridesType = {
  root?: p.Flex<"div">;
  columns?: p.Flex<"div">;
  img?: p.Flex<typeof p.PlasmicImg>;
  resourceNameMobile?: p.Flex<"h1">;
  resourceName?: p.Flex<"h1">;
  newsLetter?: p.Flex<typeof NewsLetter>;
  visitSite?: p.Flex<typeof Button>;
  shareSite?: p.Flex<typeof Button>;
};

export interface DefaultResourceModalProps {
  resourceDescription?: React.ReactNode;
  resourceLink?: React.ReactNode;
  resourceDescription2?: React.ReactNode;
  resourceLinkMobile?: React.ReactNode;
  resourceClicks?: React.ReactNode;
  resourceClicks2?: React.ReactNode;
  resourceImage?: React.ComponentProps<typeof p.PlasmicImg>["src"];
  className?: string;
}

const $$ = {};

function PlasmicResourceModal__RenderFunc(props: {
  variants: PlasmicResourceModal__VariantsArgs;
  args: PlasmicResourceModal__ArgsType;
  overrides: PlasmicResourceModal__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {
          resourceImage:
            "https://firebasestorage.googleapis.com/v0/b/ideahub-b5d59.appspot.com/o/brandmark-icon-filled-256.png?alt=media&token=f3fb077a-d37c-4675-91b6-8caabb398b29"
        },
        props.args
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const currentUser = p.useCurrentUser?.() || {};

  const globalVariants = ensureGlobalVariants({
    screen: useScreenVariants_5VS0GwAl4()
  });

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        sty.root
      )}
    >
      <div
        data-plasmic-name={"columns"}
        data-plasmic-override={overrides.columns}
        className={classNames(projectcss.all, sty.columns)}
      >
        <div className={classNames(projectcss.all, sty.column___0UcGc)}>
          <div className={classNames(projectcss.all, sty.freeBox__ubIi)}>
            <div className={classNames(projectcss.all, sty.freeBox__g6Dbd)}>
              <p.PlasmicImg
                data-plasmic-name={"img"}
                data-plasmic-override={overrides.img}
                alt={""}
                className={classNames(sty.img)}
                displayHeight={"270px"}
                displayMaxHeight={"none"}
                displayMaxWidth={"none"}
                displayMinHeight={"0"}
                displayMinWidth={"0"}
                displayWidth={
                  hasVariant(globalVariants, "screen", "mobileOnly")
                    ? "100%"
                    : "200px"
                }
                loading={"lazy"}
                src={args.resourceImage}
              />
            </div>
            <div className={classNames(projectcss.all, sty.freeBox__a6Dwi)}>
              <div className={classNames(projectcss.all, sty.freeBox__tWGB)}>
                <div
                  className={classNames(projectcss.all, sty.freeBox___8UjhH)}
                >
                  <h1
                    data-plasmic-name={"resourceNameMobile"}
                    data-plasmic-override={overrides.resourceNameMobile}
                    className={classNames(
                      projectcss.all,
                      projectcss.h1,
                      projectcss.__wab_text,
                      sty.resourceNameMobile
                    )}
                  >
                    {"Resource Name"}
                  </h1>
                </div>
                <div className={classNames(projectcss.all, sty.freeBox__nbMpi)}>
                  <Icon5Icon
                    className={classNames(projectcss.all, sty.svg__gby9S)}
                    role={"img"}
                  />

                  <a
                    className={classNames(
                      projectcss.all,
                      projectcss.a,
                      sty.link__seeJx
                    )}
                  >
                    {p.renderPlasmicSlot({
                      defaultContents: "www.websitelink.com",
                      value: args.resourceLinkMobile,
                      className: classNames(sty.slotTargetResourceLinkMobile)
                    })}
                  </a>
                </div>
              </div>
              <div className={classNames(projectcss.all, sty.freeBox__t2Jd)}>
                <Icon6Icon
                  className={classNames(projectcss.all, sty.svg__peIzw)}
                  role={"img"}
                />

                <div className={classNames(projectcss.all, sty.freeBox__oUs1N)}>
                  {p.renderPlasmicSlot({
                    defaultContents: "3.2 Clicks",
                    value: args.resourceClicks2,
                    className: classNames(sty.slotTargetResourceClicks2)
                  })}
                </div>
              </div>
            </div>
            <div className={classNames(projectcss.all, sty.freeBox__i1FkR)}>
              {(
                hasVariant(globalVariants, "screen", "mobileOnly")
                  ? false
                  : true
              )
                ? p.renderPlasmicSlot({
                    defaultContents:
                      "Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature",
                    value: args.resourceDescription,
                    className: classNames(sty.slotTargetResourceDescription)
                  })
                : null}
            </div>
            {(
              hasVariant(globalVariants, "screen", "mobileOnly") ? true : false
            ) ? (
              <div className={classNames(projectcss.all, sty.freeBox___65Fcw)}>
                {p.renderPlasmicSlot({
                  defaultContents:
                    "Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature",
                  value: args.resourceDescription2,
                  className: classNames(sty.slotTargetResourceDescription2)
                })}
              </div>
            ) : null}
          </div>
        </div>
        <div className={classNames(projectcss.all, sty.column__akMzc)}>
          <div className={classNames(projectcss.all, sty.freeBox__aTfI1)}>
            <div className={classNames(projectcss.all, sty.freeBox__iBq4Q)}>
              <div className={classNames(projectcss.all, sty.freeBox__grlHt)}>
                <div
                  className={classNames(projectcss.all, sty.freeBox___71McY)}
                >
                  <h1
                    data-plasmic-name={"resourceName"}
                    data-plasmic-override={overrides.resourceName}
                    className={classNames(
                      projectcss.all,
                      projectcss.h1,
                      projectcss.__wab_text,
                      sty.resourceName
                    )}
                  >
                    {"You won't believe what happens next."}
                  </h1>
                </div>
                <div className={classNames(projectcss.all, sty.freeBox__nGr4H)}>
                  <LinksvgIcon
                    className={classNames(projectcss.all, sty.svg__u3F3Z)}
                    role={"img"}
                  />

                  <a
                    className={classNames(
                      projectcss.all,
                      projectcss.a,
                      sty.link__ii6Fy
                    )}
                    href={"#"}
                    target={"_blank"}
                  >
                    {p.renderPlasmicSlot({
                      defaultContents: "www.websitelink.com",
                      value: args.resourceLink,
                      className: classNames(sty.slotTargetResourceLink)
                    })}
                  </a>
                </div>
                <div className={classNames(projectcss.all, sty.freeBox__tivl)}>
                  <AdsClicksvgIcon
                    className={classNames(projectcss.all, sty.svg__cmOO)}
                    role={"img"}
                  />

                  <div
                    className={classNames(projectcss.all, sty.freeBox__iKb3M)}
                  >
                    {p.renderPlasmicSlot({
                      defaultContents: "3.2k Clicks",
                      value: args.resourceClicks,
                      className: classNames(sty.slotTargetResourceClicks)
                    })}
                  </div>
                </div>
              </div>
              <div className={classNames(projectcss.all, sty.freeBox__efmVz)}>
                <ClosesvgIcon
                  className={classNames(projectcss.all, sty.svg__pVl79)}
                  role={"img"}
                />
              </div>
            </div>
            <NewsLetter
              data-plasmic-name={"newsLetter"}
              data-plasmic-override={overrides.newsLetter}
              className={classNames("__wab_instance", sty.newsLetter)}
            />

            <div className={classNames(projectcss.all, sty.freeBox__mxb3T)}>
              <Button
                data-plasmic-name={"visitSite"}
                data-plasmic-override={overrides.visitSite}
                className={classNames("__wab_instance", sty.visitSite)}
                color={"green"}
                link={"brandmark.io"}
                target={true}
              >
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__ws1C5
                  )}
                >
                  {"Visit Site"}
                </div>
              </Button>
            </div>
            <p.Stack
              as={"div"}
              hasGap={true}
              className={classNames(projectcss.all, sty.freeBox__x3Ul)}
            >
              <Button
                data-plasmic-name={"shareSite"}
                data-plasmic-override={overrides.shareSite}
                className={classNames("__wab_instance", sty.shareSite)}
                color={"softSand"}
                showStartIcon={true}
                startIcon={
                  <Icon2Icon
                    className={classNames(projectcss.all, sty.svg__pcVb7)}
                    role={"img"}
                  />
                }
              >
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__vaVRq
                  )}
                >
                  {"Share"}
                </div>
              </Button>
              <Button
                className={classNames("__wab_instance", sty.button__tbo86)}
                color={"blue"}
                showStartIcon={true}
                startIcon={
                  <Icon4Icon
                    className={classNames(projectcss.all, sty.svg__iwCd)}
                    role={"img"}
                  />
                }
              >
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__sUmgA
                  )}
                >
                  {"Facebook"}
                </div>
              </Button>
              <Button
                className={classNames("__wab_instance", sty.button__r6WgX)}
                color={"red"}
                showStartIcon={true}
                startIcon={
                  <Icon4Icon
                    className={classNames(projectcss.all, sty.svg__uiVdz)}
                    role={"img"}
                  />
                }
              >
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__r8Glk
                  )}
                >
                  {"Reddit"}
                </div>
              </Button>
            </p.Stack>
          </div>
        </div>
      </div>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: [
    "root",
    "columns",
    "img",
    "resourceNameMobile",
    "resourceName",
    "newsLetter",
    "visitSite",
    "shareSite"
  ],
  columns: [
    "columns",
    "img",
    "resourceNameMobile",
    "resourceName",
    "newsLetter",
    "visitSite",
    "shareSite"
  ],
  img: ["img"],
  resourceNameMobile: ["resourceNameMobile"],
  resourceName: ["resourceName"],
  newsLetter: ["newsLetter"],
  visitSite: ["visitSite"],
  shareSite: ["shareSite"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  columns: "div";
  img: typeof p.PlasmicImg;
  resourceNameMobile: "h1";
  resourceName: "h1";
  newsLetter: typeof NewsLetter;
  visitSite: typeof Button;
  shareSite: typeof Button;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicResourceModal__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicResourceModal__VariantsArgs;
    args?: PlasmicResourceModal__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicResourceModal__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    /* Specify args directly as props*/ Omit<
      PlasmicResourceModal__ArgsType,
      ReservedPropsType
    > &
    /* Specify overrides for each element directly as props*/ Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    /* Specify props for the root element*/ Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: [...PlasmicDescendants[nodeName]],
          internalArgPropNames: PlasmicResourceModal__ArgProps,
          internalVariantPropNames: PlasmicResourceModal__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicResourceModal__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicResourceModal";
  } else {
    func.displayName = `PlasmicResourceModal.${nodeName}`;
  }
  return func;
}

export const PlasmicResourceModal = Object.assign(
  // Top-level PlasmicResourceModal renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    columns: makeNodeComponent("columns"),
    img: makeNodeComponent("img"),
    resourceNameMobile: makeNodeComponent("resourceNameMobile"),
    resourceName: makeNodeComponent("resourceName"),
    newsLetter: makeNodeComponent("newsLetter"),
    visitSite: makeNodeComponent("visitSite"),
    shareSite: makeNodeComponent("shareSite"),

    // Metadata about props expected for PlasmicResourceModal
    internalVariantProps: PlasmicResourceModal__VariantProps,
    internalArgProps: PlasmicResourceModal__ArgProps
  }
);

export default PlasmicResourceModal;
/* prettier-ignore-end */
